module.exports = __webpack_public_path__ + "static/media/medqair.37586709.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/medqair.webp
// module id = 458
// module chunks = 0